export const constants = {
  ASYNC_STORAGE_KEYS: {
    ACCESS_TOKEN: "accessToken",
    REFRESH_TOKEN: "refreshToken",
  },
  DEFAULT_LANGUAGE: "en" as const,
} as const;
